import useUserStore from '@/stores/userStore'
import r from '@/utils/request'
import { fetchEventSource, type EventSourceMessage } from '@microsoft/fetch-event-source'

/**
 * 获取对话列表接口
 * @returns 响应数据
 */
export const getConversationListApi = (params: IBasePageParams) => {
  return r.get<IBasePageRes<IConversation>>('/app/ai/conversation', params)
}

/**
 * 流式聊天接口
 * @param data 请求参数
 * @param ctrl 控制器
 * @param onMessage 消息回调
 * @param onError 错误回调
 * @param onClose 关闭回调
 * @returns
 */
export const streamChatCompletionApi = (
  data: IStreamChatCompletionReq,
  ctrl: AbortController,
  onMessage: (event: EventSourceMessage) => void,
  onError: (event: any) => void,
  onClose: () => void,
) => {
  return fetchEventSource(import.meta.env.VITE_APP_API + '/app/ai/conversation/chat', {
    method: 'POST',
    headers: {
      Authorization: useUserStore().token || '',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
    signal: ctrl.signal,
    openWhenHidden: true,
    onmessage: onMessage,
    onerror: onError,
    onclose: onClose,
  })
}

/**
 * 获取对话历史接口
 * @param conversationId 对话ID
 * @returns 响应数据
 */
export const getConversationHistoryApi = (conversationId: number) => {
  return r.get<IChatMessage[]>(`/app/ai/conversation/history/${conversationId}`)
}

/**
 * 创建对话接口
 * @returns 响应数据
 */
export const createConversationApi = () => {
  return r.post('/app/ai/conversation')
}

/**
 * 删除对话接口
 * @param conversationId 对话ID
 * @returns 响应数据
 */
export const deleteConversationApi = (conversationIds: number[]) => {
  return r.delete(`/app/ai/conversation`, conversationIds)
}

/**
 * 上传文件接口
 * @param file 文件
 * @returns 响应数据
 */
export const uploadFileApi = (file: ISysFile) => {
  return r.post<ISysFile>(`/app/sys/file/upload`, file)
}
